export default "__VITE_PUBLIC_ASSET__63865ce3__"